
<template>
	<div class="box">
		<nav>
			<router-link :to="v.url" tag="div" v-for="(v,k) in myrouter" :key="k" active-class="checked" replace>
				{{v.name}}
			</router-link>
		</nav>
		<router-view/>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				myrouter: [
				]
			}
		},
	}
</script>

<style scoped lang="less">

</style>
